import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetProjectSearchParams } from '@/shared/api/end-points/project'
import { ProjectSearchResponse } from '../../lib'

const getProjectSearch = async (params: GetProjectSearchParams) => {
  return await api.json<ProjectSearchResponse>(API_END_POINTS.project.getProjectSearch(params))
}

export default getProjectSearch
